module.exports = __webpack_public_path__ + "086627afd12b18cbd8bfbbce22700fad.png";